"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContextPanelProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
// Reducer
function useContextPanel() {
    const { openSectionId, setOpenSectionId } = (0, react_1.useContext)(ContextPanelContext);
    const open = !!openSectionId;
    function openSection(sectionId) {
        setOpenSectionId(sectionId);
    }
    function closeSection() {
        setOpenSectionId(null);
    }
    return {
        open,
        openSectionId,
        openSection,
        closeSection,
    };
}
exports.default = useContextPanel;
// Context creation
const initialData = {
    openSectionId: null,
    setOpenSectionId: () => { },
};
const ContextPanelContext = (0, react_1.createContext)(initialData);
// Provider
const ContextPanelProvider = ({ children, }) => {
    const [openSectionId, setOpenSectionId] = (0, react_1.useState)(null);
    return ((0, jsx_runtime_1.jsx)(ContextPanelContext.Provider, Object.assign({ value: {
            openSectionId,
            setOpenSectionId,
        } }, { children: children })));
};
exports.ContextPanelProvider = ContextPanelProvider;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlQ29udGV4dFBhbmVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvcHJvamVjdC9jb250ZXh0L3VzZUNvbnRleHRQYW5lbC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLGlDQUF1RTtBQVl2RSxVQUFVO0FBQ1YsU0FBd0IsZUFBZTtJQUNyQyxNQUFNLEVBQUUsYUFBYSxFQUFFLGdCQUFnQixFQUFFLEdBQUcsSUFBQSxrQkFBVSxFQUNwRCxtQkFBbUIsQ0FDcEIsQ0FBQztJQUNGLE1BQU0sSUFBSSxHQUFHLENBQUMsQ0FBQyxhQUFhLENBQUM7SUFFN0IsU0FBUyxXQUFXLENBQUMsU0FBaUI7UUFDcEMsZ0JBQWdCLENBQUMsU0FBUyxDQUFDLENBQUM7SUFDOUIsQ0FBQztJQUVELFNBQVMsWUFBWTtRQUNuQixnQkFBZ0IsQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQsT0FBTztRQUNMLElBQUk7UUFDSixhQUFhO1FBQ2IsV0FBVztRQUNYLFlBQVk7S0FDYixDQUFDO0FBQ0osQ0FBQztBQXBCRCxrQ0FvQkM7QUFFRCxtQkFBbUI7QUFDbkIsTUFBTSxXQUFXLEdBQXNCO0lBQ3JDLGFBQWEsRUFBRSxJQUFJO0lBQ25CLGdCQUFnQixFQUFFLEdBQUcsRUFBRSxHQUFFLENBQUM7Q0FDM0IsQ0FBQztBQUNGLE1BQU0sbUJBQW1CLEdBQUcsSUFBQSxxQkFBYSxFQUFvQixXQUFXLENBQUMsQ0FBQztBQUUxRSxXQUFXO0FBQ0osTUFBTSxvQkFBb0IsR0FBRyxDQUFDLEVBQ25DLFFBQVEsR0FDa0IsRUFBRSxFQUFFO0lBQzlCLE1BQU0sQ0FBQyxhQUFhLEVBQUUsZ0JBQWdCLENBQUMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsSUFBSSxDQUFDLENBQUM7SUFFekQsT0FBTyxDQUNMLHVCQUFDLG1CQUFtQixDQUFDLFFBQVEsa0JBQzNCLEtBQUssRUFBRTtZQUNMLGFBQWE7WUFDYixnQkFBZ0I7U0FDakIsZ0JBRUEsUUFBUSxJQUNvQixDQUNoQyxDQUFDO0FBQ0osQ0FBQyxDQUFDO0FBZlcsUUFBQSxvQkFBb0Isd0JBZS9CIn0=